"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

var _settings = require("@izzistock/settings");

var _Text = _interopRequireDefault(require("../Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var disabledOpacity = 0.5;

var _default = function _default(_ref) {
  var title = _ref.title,
      onPress = _ref.onPress,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 'auto' : _ref$width,
      paddingBottom = _ref.paddingBottom;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, _extends({
    style: [style.button, width === 'auto' ? {} : {
      width: width
    }, paddingBottom ? {
      paddingBottom: paddingBottom
    } : {}, disabled ? {
      opacity: disabledOpacity,
      backgroundColor: _settings.colors.primary
    } : {}],
    onPress: disabled ? undefined : onPress
  }, disabled ? {
    activeOpacity: disabledOpacity
  } : {}), loading ? /*#__PURE__*/_react["default"].createElement(_reactNative.ActivityIndicator, null) : /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: 'primary'
  }, title));
};

exports["default"] = _default;

var style = _reactNative.StyleSheet.create({
  button: {
    backgroundColor: _settings.colors.primary,
    padding: 10,
    justifyContent: 'center',
    alignItems: 'center'
  }
});